var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 20.4477 4.44772 20 5 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6543 4.58835C15.8733 3.8073 14.6069 3.8073 13.8259 4.58835L6.91979 11.4944L6.00198 15.9981L10.5056 15.0802L17.4117 8.17414C18.1927 7.39309 18.1927 6.12675 17.4117 5.3457L16.6543 4.58835ZM12.4117 3.17413C13.9738 1.61204 16.5064 1.61204 18.0685 3.17413L18.8259 3.93149C20.388 5.49359 20.388 8.02626 18.8259 9.58835L11.9198 16.4944C11.6423 16.7718 11.2894 16.9615 10.905 17.0399L6.40141 17.9578C4.99686 18.2441 3.75603 17.0033 4.04226 15.5987L4.96007 11.095C5.03842 10.7106 5.22813 10.3576 5.50558 10.0802L12.4117 3.17413Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLine);
export default __webpack_public_path__ + "static/media/edit-line.ce974e650c24ebfb6c55dd5397548848.svg";
export { ForwardRef as ReactComponent };